import { getSearchParams, getSearchResults, search } from 'b2b-common/services/api/booking'

export default {
  initDataLoaded: false,
  distribution: null,
  params: {
    rooms: [{ adults: 2, childAges: [] }]
  },
  results: [],
  pageNumber: 1,
  selectedResultsPerPage: 50,

  resultsPerPage: [
    { label: '50 rezultate/pagina', value: 50 },
    { label: '100 rezultate/pagina', value: 100 },
    { label: 'toate rezultatele', value: 0 }
  ],

  init () {
    if (this.initDataLoaded) return Promise.resolve(true)
    const initialRequests = [
      getSearchParams(),
      getSearchResults()
    ]
    return Promise.all(initialRequests).then(res => {
      this.params = res[0]
      this.results = res[1]
      this.initDataLoaded = true
      return true
    })
  },

  search (params) {
    return search(params).then(res => {
      this.results = res
      return this.results
    })
  }

}
